// Pathify
import { make } from 'vuex-pathify'
import axios from 'axios'
import router from '@/router'
import { default as referentials } from './referentials'
import { default as plans } from './plans'
import { default as projects } from './projects'
import message from './messages'
import auth from './authentification'

const state = {
  language: 'la',
  informationDocuments: []
}

const mutations = {
  setLanguage(state, payload) {
    state.language = payload;
  },
  setInformationDocuments(state, payload) {
    state.informationDocuments = payload;
  }
}

const actions = {
 updateLanguage: ({ state, commit, dispatch }, payload) => {
    try{

      axios.post(`/api/language`,{language: payload}).then(response => {

        commit('setLanguage', payload);

      }).then(function(){

        if(router.currentRoute.path === '/disaster_need/'){
            dispatch('plans/getNeeds',null,{root: true});
        }else if(router.currentRoute.path === '/project_application_provision/'){
            dispatch('projects/getDataReceptionProvinceList',null,{root: true});
        }else if(router.currentRoute.path === '/project_application/' || router.currentRoute.path ==='/project_application_approval/'){
            dispatch('projects/getProjectListApplication',null,{root: true});
        }else if(router.currentRoute.path === '/project_contractor/' || router.currentRoute.path ==='/project_budget/'){
            dispatch('projects/getProjectContractorList',null,{root: true});
        }else if(router.currentRoute.path === '/implementation_reporting/' || router.currentRoute.path ==='/implementation_approval/'){
            dispatch('projects/getProjectOnGoingList',null,{root: true});
        }else if(router.currentRoute.path === '/completion_reporting/' || router.currentRoute.path ==='/completion_approval/' || router.currentRoute.path ==='/payment_progress/'){
            dispatch('projects/getProjectCompletedList',null,{root: true});
        }else if(router.currentRoute.path === '/project_overview/'){
            dispatch('projects/getAllProjectList',null,{root: true});
        }else if(router.currentRoute.path === '/dashboard/'){
            dispatch('projects/getProjectCompletedList',null,{root: true});
        }else if(router.currentRoute.path === '/user_right_management/'){
            dispatch('user/getUserList',null,{root: true});
            dispatch('referentials/getUserProfileList',null,{root: true});
            dispatch('referentials/getUserTypeList',null,{root: true});
        }

        //dispatch('referentials/getAssetTypeList',null,{root: true});
        //dispatch('referentials/getBridgeCategoryList',null,{root: true});
        //dispatch('referentials/getBridgeWorkTypeList',null,{root: true});
        //dispatch('referentials/getBuildingCategory',null,{root: true});
        //dispatch('referentials/getBuildingMinistryList',null,{root: true});
        //dispatch('referentials/getBuildingTypeList',null,{root: true});
        //dispatch('referentials/getBuildingWorkTypeList',null,{root: true});
        dispatch('referentials/getContractorExperienceList',null,{root: true});
        dispatch('referentials/getCostCategoryList',null,{root: true});
        //dispatch('referentials/getDesignMethodList',null,{root: true});
        dispatch('referentials/getDisasterCategoryList',null,{root: true});
        dispatch('referentials/getDistrictList',null,{root: true});
        //dispatch('referentials/getDistrictOfUserProfileList',null,{root: true});
        //dispatch('referentials/getEquipmentCategoryList',null,{root: true});
        //dispatch('referentials/getEquipmentWorkTypeList',null,{root: true});
        //dispatch('referentials/getFunctionList',null,{root: true});
        //dispatch('referentials/getFundingSourceList',null,{root: true});
        //dispatch('referentials/getIrrigationCategoryList',null,{root: true});
        //dispatch('referentials/getIrrigationTypeList',null,{root: true});
        //dispatch('referentials/getIrrigationWorkTypeList',null,{root: true});
        //dispatch('referentials/getMilestoneStatusList',null,{root: true});
        //dispatch('referentials/getProcurementTypeList',null,{root: true});
        dispatch('referentials/getProjectClassList',null,{root: true});
        dispatch('referentials/getProjectPictureCategoryList',null,{root: true});
        dispatch('referentials/getProjectApplicationStatusList',null,{root: true});
        dispatch('referentials/getProjectCompletionStatusList',null,{root: true});
        //dispatch('referentials/getProjectMarkList',null,{root: true});
        dispatch('referentials/getProjectStatusList',null,{root: true});
        dispatch('referentials/getProjectSectorList',null,{root: true});
        dispatch('referentials/getProjectTypeList',null,{root: true});
        dispatch('referentials/getDomainList',null,{root: true});
        //dispatch('referentials/getProjectWorkTypeList',null,{root: true});
        dispatch('referentials/getProvinceList',null,{root: true});
        dispatch('projects/getProjectOwnerList',null,{root: true});
        //dispatch('referentials/getRiskCostLevelList',null,{root: true});
        //dispatch('referentials/getRiskResourceAvailabilityLevelList',null,{root: true});
        //dispatch('referentials/getRiskScheduleLevelList',null,{root: true});
        //dispatch('referentials/getRiskScopeLevelList',null,{root: true});
        //dispatch('referentials/getRiverList',null,{root: true});
        //dispatch('referentials/getRoadClassList',null,{root: true});
        //dispatch('referentials/getRoadSurfaceList',null,{root: true});
        //dispatch('referentials/getRoadTypeList',null,{root: true});
        //dispatch('referentials/getRoadWorkTypeList',null,{root: true});
        dispatch('referentials/getVillageList',null,{root: true});
        //dispatch('referentials/getYearList',null,{root: true});
        dispatch('referentials/getInstructionDocumentList',null,{root: true});
        dispatch('referentials/getReportingDocumentList',null,{root: true});
        dispatch('referentials/getCompletionDocumentList',null,{root: true});
        dispatch('plans/getDataReceptionProvinceList',null,{root: true});

      });

    } catch(error){
      commit('setLanguage', []);
    }
  },
  getInformationDocuments: ({ state, commit }) => {
    try{
      axios.get(`/api/information_documents`).then(response => {
        commit('setInformationDocuments', response.data);
      });
    } catch(error){
      commit('setInformationDocuments', []);
    }
  },
  downloadInformationDocuments: ({ state, commit, dispatch }, payload) => {
    try{

      axios.post(`/api/download_information_document`,payload).then(response => {

        //https://stackoverflow.com/questions/35038884/download-file-from-bytes-in-javascript
        if(response.data.file){
          var bytes = new Uint8Array(response.data.file.data); // pass your byte response to this constructor
          var blob_type = response.data.mimetype;
          var blob=new Blob([bytes], {type: blob_type});// change resultByte to bytes

          var link=document.createElement('a');
          link.href=window.URL.createObjectURL(blob);
          link.download=response.data.original_name;
          link.click();

        }

      });
    } catch(error){
      commit('setInformationDocuments', []);
    }
  },
  uploadInformationDocuments: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/upload_information_document`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {  
        message.mutations.setConfirmationUpdate(message.state, true);
        dispatch('getInformationDocuments');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setInformationDocuments', []);
    }
  },
  addInformationDocuments: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/add_information_document`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {  
        message.mutations.setConfirmationAdd(message.state, true);
        dispatch('getInformationDocuments');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setInformationDocuments', []);
    }
  },
  deleteInformationDocuments: ({ state, commit, dispatch }, payload) => {
    try{
      axios.post(`/api/delete_information_documents`, payload).then(response => {
        message.mutations.setConfirmationDelete(message.state, true);
        dispatch('getInformationDocuments');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setInformationDocuments', []);
    }
  },
}

const getters = {
  language: state => {
    return state.language
  },
  informationDocuments: state => {
    return state.informationDocuments
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
